// Geo-location service for detecting user's country via IP

export interface GeoLocation {
    countryCode: string;
    countryName: string;
    isIndia: boolean;
}

const INDIA_COUNTRY_CODE = 'IN';

// List of countries for dropdown
export const COUNTRIES = [
    { code: 'IN', name: 'India' },
    { code: 'US', name: 'United States' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'SG', name: 'Singapore' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'JP', name: 'Japan' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SE', name: 'Sweden' },
    { code: 'NO', name: 'Norway' },
    { code: 'DK', name: 'Denmark' },
    { code: 'IE', name: 'Ireland' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'PH', name: 'Philippines' },
    { code: 'TH', name: 'Thailand' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'VN', name: 'Vietnam' },
    { code: 'KR', name: 'South Korea' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'OTHER', name: 'Other' },
];

export async function detectCountry(): Promise<GeoLocation> {
    try {
        // Using ipapi.co - free tier allows 1000 requests/day
        const response = await fetch('https://ipapi.co/json/', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to detect location');
        }

        const data = await response.json();
        const countryCode = data.country_code || INDIA_COUNTRY_CODE;
        const countryName = data.country_name || 'India';

        return {
            countryCode,
            countryName,
            isIndia: countryCode === INDIA_COUNTRY_CODE,
        };
    } catch (error) {
        console.warn('Geo-location detection failed, defaulting to India:', error);
        // Default to India if detection fails
        return {
            countryCode: INDIA_COUNTRY_CODE,
            countryName: 'India',
            isIndia: true,
        };
    }
}

export function isIndiaCountry(countryCode: string): boolean {
    return countryCode === INDIA_COUNTRY_CODE;
}

export function getCountryName(countryCode: string): string {
    const country = COUNTRIES.find(c => c.code === countryCode);
    return country?.name || 'Other';
}
